export {
  AreaChart,
  LineChart,
  BarChart,
  DonutChart,
  BubbleChart,
  GanttChart,
  DagreGraph,
  DualChart,
  SankeyChart,
  TopoJSONMap,
  DottedMap
} from "vue-chrts";
